module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"stbserial":"Set-Top Box Serial Number","new number":"New number","discard":"Discard","change":"Change"},"de":{"stbserial":"Set-Top Box Seriennummer","new number":"Neue Nummer","discard":"Verwerfen","change":"Ändern"}}')
  delete Component.options._Ctor
}
